import { parseApiError } from './apiError';

export const loginWithGoogleIdToken = async (idToken: string) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}api/auth/google/web`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ idToken })
  });
  if (!res.ok) throw await parseApiError(res, 'Connexion Google impossible');
  return res.json();
};
